import axios, { AxiosRequestConfig } from "axios";
import { addSagAuthInterceptor } from "@sazka/utils/http-clients/sag-auth-interceptor";
import { useSagOptions } from "@sazka/utils/http-clients/use-sag-options";
import { addPlayerIdInterceptor } from "../../interceptors/player-id-interceptor";
import { addSessionTokenInterceptor } from "../../interceptors/session-token-interceptor";

const { getSagApiUrl } = useSagOptions();

/**
 * Axios basic configuration
 * Some general configuration can be added like timeout, headers, params etc. More details can be found on https://github.com/axios/axios
 * */
const config: AxiosRequestConfig = {
    baseURL: appSettings["Integrations:Loyalty:PlayerData:LocalDev"] ?? getSagApiUrl("ls-player-data-public"),
};

const playerDataHttpClient = axios.create(config);

/** Adding the request interceptors */
addSagAuthInterceptor(playerDataHttpClient);
addSessionTokenInterceptor(playerDataHttpClient);
addPlayerIdInterceptor(playerDataHttpClient);

export { playerDataHttpClient };
